import React from 'react'
import Navbar from '../components/Navbar'
import Signup from '../components/Signup'
import Footer from '../components/Footer'

function SignupPage() {
    return (
        <>
            <Navbar />
            <Signup />
            <Footer />
        </>
    )
}

export default SignupPage